import { RoleIds } from '@efexteam/permission-manager';
import { z } from 'zod';

// Define individual field schemas
const emailSchema = z.object({
  label: z.string().min(1, 'Email is required'),
  value: z.number().min(1, 'Email is required'),
});

const userNameSchema = z.string().min(1, 'Name is required');

const roleIdSchema = z
  .number()
  .refine((val) => Object.values(RoleIds).includes(val), {
    message: 'Invalid role selected',
  });

// Step-specific schemas
export const addMemberStepSchema = z.object({
  email: emailSchema,
  userName: userNameSchema,
});

export const assignRoleStepSchema = z.object({
  roleId: roleIdSchema,
});

// Complete schema for the entire form
export const addMemberSchema = z.object({
  email: emailSchema,
  userName: userNameSchema,
  roleId: roleIdSchema,
  authorizationTerms: z.boolean().optional(),
});

export type IAddMemberSchema = z.infer<typeof addMemberSchema>;

// Helper function to get fields to validate for each step
export const getFieldsForStep = (step: string): (keyof IAddMemberSchema)[] => {
  switch (step) {
    case 'ADD_MEMBER':
      return ['email', 'userName'];
    case 'ASSIGN_ROLE':
      return ['roleId'];
    default:
      return ['email', 'userName', 'roleId'];
  }
};
